import { useContext, useState } from "react";
import { EditorContext } from "../context/EditorContextValue";

// Dropvak onderaan het canvas van de editor: wat je hier loslaat, komt
// onderaan de rapportage.
//
// Nodig omdat CanvasNode geen plek heeft onder het onderste blok: het onderste
// stuk van een container hoort bij het laatste blok erin, en de rapportage
// zelf heeft standaard geen ruimte onder dat blok. Een nieuwe container direct
// onder de onderste container slepen lukte daardoor alleen op precies één
// pixelrij. Updateverzoek Team Sportclub, 2026-10-14.

/** @typedef {import("../widgets").BaseWidget} BaseWidget */

/**
 * @param {object} props
 * @param {string} props.rootId - ID van de bovenste container van de rapportage
 * @param {BaseWidget[]} props.widgets - Alle widgets van de rapportage
 * @returns {JSX.Element|null}
 */
export const CanvasEndDropZone = ({ rootId, widgets }) => {
    const editorCtx = useContext(EditorContext);
    const [active, setActive] = useState(false);

    if (!editorCtx) return null;

    return (
        <div
            data-testid="canvas-end-dropzone"
            className={`canvas-end-dropzone ${active ? 'canvas-end-dropzone--active' : ''}`}
            onDragOver={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setActive(true);
            }}
            onDragLeave={() => setActive(false)}
            onDrop={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setActive(false);

                const droppedId = e.dataTransfer.getData('id');
                const type = e.dataTransfer.getData('type');

                // rebuildOrder telt de plek tussen de broers zonder het
                // gesleepte blok zelf, dus dat telt hier ook niet mee.
                const targetIndex = widgets
                    .filter(w => w.parent === rootId && !w.deleted && w.id !== droppedId)
                    .length;

                editorCtx.handleWidgetDrop({
                    droppedId,
                    type,
                    parentId: rootId,
                    targetIndex,
                });
            }}
        />
    );
};

export default CanvasEndDropZone;
